import { defineComponent, ref, computed, onBeforeUnmount, watch, openBlock, createBlock, Transition, withCtx, withDirectives, createElementBlock, renderSlot, normalizeProps, guardReactiveProps, vShow, Fragment, createCommentVNode } from 'vue';
import { p as pxToRem } from '../../px-to-rem-a21cdf39.js';
import { n as setStyle, r as requestAF, b as reflow, o as removeStyle, c as cancelAF, q as getBCR } from '../../dom-11141778.js';
import { s as styleInject } from '../../style-inject.es-87955792.js';
import 'lodash/get';
import 'lodash/isElement';

var script = defineComponent({
  name: 'OrCollapse',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
      required: false
    },
    isVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    keepState: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, {
    emit
  }) {
    // data
    const isActive = ref(props.modelValue || props.isVisible);
    const reqAF = ref(null);
    const slotScope = computed(() => ({
      isVisible: isActive,
      hide
    }));
    // methods
    function hide() {
      isActive.value = false;
    }
    function beforeEnter(el) {
      setStyle(el, 'height', 0);
      setStyle(el, 'overflow', 'hidden');
    }
    function enter(el) {
      const {
        scrollHeight
      } = el;
      reqAF.value = requestAF(() => {
        reflow(el);
        setStyle(el, 'height', pxToRem(scrollHeight));
      });
    }
    function afterEnter(el) {
      removeStyle(el, 'height');
      removeStyle(el, 'overflow');
      cancelAF(reqAF.value);
    }
    function beforeLeave(el) {
      setStyle(el, 'overflow', 'hidden');
    }
    function leave(el) {
      setStyle(el, 'height', 'auto');
      setStyle(el, 'display', 'block');
      reqAF.value = requestAF(() => {
        var _a;
        setStyle(el, 'height', pxToRem((_a = getBCR(el)) === null || _a === void 0 ? void 0 : _a.height));
        reflow(el);
        setStyle(el, 'height', 0);
      });
    }
    function afterLeave(el) {
      removeStyle(el, 'height');
      removeStyle(el, 'overflow');
      cancelAF(reqAF.value);
    }
    // hooks
    onBeforeUnmount(() => {
      isActive.value = false;
      reqAF.value = null;
    });
    // watchers
    watch([() => props.modelValue, () => props.isVisible], ([newValue, newIsVisible]) => {
      if (newValue !== isActive.value || newIsVisible !== isActive.value) {
        isActive.value = newValue || newIsVisible;
      }
    });
    watch(isActive, (nv, ov) => {
      if (nv !== ov) {
        emit('update:modelValue', nv);
      }
    });
    return {
      // data
      isActive,
      slotScope,
      // methods
      beforeEnter,
      enter,
      afterEnter,
      beforeLeave,
      leave,
      afterLeave
    };
  }
});

const _hoisted_1 = {
  key: 0,
  class: "or-collapse"
};
const _hoisted_2 = {
  key: 0,
  class: "or-collapse"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    onBeforeEnter: _ctx.beforeEnter,
    onEnter: _ctx.enter,
    onAfterEnter: _ctx.afterEnter,
    onBeforeLeave: _ctx.beforeLeave,
    onLeave: _ctx.leave,
    onAfterLeave: _ctx.afterLeave
  }, {
    default: withCtx(() => [_ctx.keepState ? withDirectives((openBlock(), createElementBlock("div", _hoisted_1, [renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps(_ctx.slotScope)))], 512 /* NEED_PATCH */)), [[vShow, _ctx.isActive]]) : (openBlock(), createElementBlock(Fragment, {
      key: 1
    }, [_ctx.isActive ? (openBlock(), createElementBlock("div", _hoisted_2, [renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps(_ctx.slotScope)))])) : createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */))]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["onBeforeEnter", "onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"]);
}

var css_248z = ".or-collapse[data-v-5b8d3198] {\n  padding: 0;\n  transition-timing-function: var(--t-func);\n  transition-duration: var(--t-duration);\n  transition-property: height;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-5b8d3198";
script.__file = "src/components/or-collapse/OrCollapse.vue";

export { script as OrCollapse };
